export { default } from './DeleteTooltip';
export { default as DeleteTooltip } from './DeleteTooltip';
